import { configureOccTransport } from "~/common/api/occTransport";
import { apiPOST, apiPUT } from "../apiCallsService";
import { occBaseSiteUrl, occFetch, occUrl } from "./occFetch";
import { occCartUserPath } from "./occUserPath";

export function registerOccTransport(): void {
  configureOccTransport({
    request: (url, init, options) => occFetch(url, init, options),
    post: apiPOST,
    put: apiPUT,
    baseSiteUrl: occBaseSiteUrl,
    url: occUrl,
    userPath: occCartUserPath,
  });
}
